module.exports = __webpack_public_path__ + "static/2a27b153-f37b-4c53-8085-a421c9223c55-700.11b3b18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/penguin-arctic-blue/2a27b153-f37b-4c53-8085-a421c9223c55-700.jpg
// module id = 1027
// module chunks = 168707334958949